import React from 'react'
import DefaultButton from '../../components/DefaultButton'
import { getAssetUrl } from '../../helper/BaseUrl'


export default function DynamicPageBanner({ data }) {
    if (!data?.title) return null;
    const bannerImageUrl = getAssetUrl(data?.banner_image);
  return (
    <>
      <section className="human-resources-bannner header-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <h1 className="heading">{data?.title}</h1>
              <div dangerouslySetInnerHTML={{ __html: data?.banner_description }} />
              <DefaultButton to={data?.banner_button_url} text={data?.banner_button_name} color />
            </div>
          </div>
        </div>
        {bannerImageUrl && <img src={bannerImageUrl} alt={data?.alt_banner_image || data?.title || "Page banner"} />}
      </section>
    </>
  )
}
